<template>
<div style="background: #000000; color: #ffffff; min-height: 100vh;">
  <div style="padding: 50px  20px; margin: 0 auto; max-width: 1000px;" v-if="!validcode">
    <div style="display: flex; margin: 0  0 100px; position: relative;">
      <img src="https://api.phabsite.com/1609352675532-favicon4.png" alt="sitedata.name" class="logoimage">
    </div>
      <h1>Welkom bij de VIP omgeving van Phabsite</h1>
      <p style="max-width: 900px;">
        Wij hebben alleen nog uw speciale code nodig. 
        Deze heeft u ontvangen in uw e-mail. 
        Mocht u het niet kunnen vinden in uw Inbox, bekijk dan ook uw Junk mail of neem <a href="https://phabsite.com/contact">contact</a> met ons op.
      </p>
      <transition>
        <alert-bar v-if="msgtext" v-bind:class="msgclass" class="alert_toast">{{msgtext}}</alert-bar>
      </transition>
    <form id="create-site">
      <input v-model="vipcode" type="text" placeholder="Jouw code..." name="user-code" class="form-control form-control-lg mr-4">
      <button name="submit-create-site" class="btn btn-lg btn-primary" @click.prevent="checkCode()"><span>Invoeren</span></button>
    </form>
  </div>
  <div style="padding: 50px  20px; margin: 0 auto; max-width: 1000px;" v-if="validcode">
    <div style="display: flex; margin: 0  0 100px; position: relative;">
      <img src="https://api.phabsite.com/1609352675532-favicon4.png" alt="sitedata.name" class="logoimage">
      <button class="btn ml-auto btn-outline-danger" @click.prevent="eraseFields()">Alles wissen</button>
    </div>
      <transition>
        <alert-bar v-if="msgtext" v-bind:class="msgclass" class="alert_toast">{{msgtext}}</alert-bar>
      </transition>

      <div class="question">
        <label>Beschrijf jouw bedrijf in 1 zin</label>
        <span>
          <input v-model="content.site_title" class="question-input title-input" style="max-width: 400px; margin-right: auto;" :class="{'isempty': content.site_title == ''}"/>
        </span>
      </div>

      <div class="question">
        <label>Beschrijf wie en hoe jij helpt</label>
        <span>
          <input v-model="content.site_description" class="question-input" :class="{'isempty': content.site_description == ''}"/>
        </span>
      </div>

      <div class="question">
        <label>Beschrijf kort hoe jij te werk gaat</label>
        <span>
          <textarea v-model="content.aboutus" class="question-input" :class="{'isempty': content.aboutus == ''}"></textarea>
        </span>
      </div>

      <div class="question question-start">
        <label>Noem de sterke punten die jouw onderneming vormgeven</label>
        <div class="questionblock" v-for="benefit, n in content.benefits">
          <span class="questionnumber">{{n + 1}}</span>
          <span>
            <input v-model="benefit.title" class="question-input title-input" style="max-width: 400px; margin-right: auto;" :class="{'isempty': benefit.title == ''}"/>
          </span>
          <span class="mt-3 mb-3">
            <textarea v-model="benefit.description" class="question-input" :class="{'isempty': benefit.description == ''}"></textarea>
          </span>
          <button class="questionadder" @click.prevent="pushItems(content.benefits)">+</button>
        </div>
      </div>

      <div class="question question-start">
        <label>Noem de belangrijkste diensten uit jouw aanbod</label>
        <div class="questionblock" v-for="offer, n in content.offers">
          <span class="questionnumber">{{n + 1}}</span>
          <span>
            <input v-model="offer.title" class="question-input title-input" style="max-width: 400px; margin-right: auto;" :class="{'isempty': offer.title == ''}"/>
          </span>
          <span class="mt-3 mb-3">
            <textarea v-model="offer.description" class="question-input" :class="{'isempty': offer.description == ''}"></textarea>
          </span>
          <button class="questionadder" @click.prevent="pushItems(content.offers)">+</button>
        </div>
      </div>

      <div class="question question-start">
        <label>Vertel kort over jouw persoon</label>
        <div class="questionblock  nonumber">
          <span>
            <input v-model="content.biotitle" class="question-input title-input" style="max-width: 400px; margin-right: auto;" :class="{'isempty': content.biotitle == ''}"/>
          </span>
          <span class="mt-3 mb-3">
            <textarea v-model="content.bio" class="question-input" :class="{'isempty': content.bio == ''}"></textarea>
          </span>
        </div>
      </div>

      <div class="question question-start">
        <label>Beschrijf wat jouw doelgroep over jou zegt</label>
        <div class="questionblock" v-for="reference, n in content.references">
          <span class="questionnumber">{{n + 1}}</span>
          <span>
            <input v-model="reference.title" class="question-input title-input" style="max-width: 400px; margin-right: auto;" :class="{'isempty': reference.title == ''}"/>
          </span>
          <span class="mt-3 mb-3">
            <textarea v-model="reference.description" class="question-input" :class="{'isempty': reference.description == ''}"></textarea>
          </span>
          <button class="questionadder" @click.prevent="pushItems(content.references)">+</button>
        </div>
      </div>

      <div class="question question-start">
        <label>Jouw e-mailadres</label>
        <span>
          <input type="email" v-model="content.email" class="question-input" style="max-width: 400px; margin-right: auto;" :class="{'isempty': content.email == ''}"/>
        </span>
      </div>

      <div class="question">
        <label>Jouw telefoonnummer</label>
        <span>
          <input v-model="content.tel" class="question-input" :class="{'isempty': content.tel == ''}"/>
        </span>
      </div>

      <div class="question">
        <label>Wil je ons nog iets belangrijks vertellen?</label>
        <span>
            <textarea v-model="content.comments" class="question-input" :class="{'isempty': content.comments == ''}"></textarea>
        </span>
      </div>

      <!--div class="question">
        <label>Upload bestanden</label>
        <span class="mt-1">
          <button class="btn btn-white mr-3">Jouw logo</button>
          <button class="btn btn-white mr-3">Afbeeldingen</button>
          <button class="btn btn-white">Documenten</button>
        </span>
      </div-->

      <div class="question question-start">
        <label></label>
        <span>
          <button class="btn ml-auto btn-primary" @click.prevent="sendForm()">Ik wil een website laten maken</button> <loader v-if="loading" style="display: inline-block; margin: 0 0 0 30px; vertical-align: -20px;"/>
          <p class="text-muted mt-4 mb-4">Bovenstaande teksten kunnen wij meteen gebruiken om jouw droombedrijf te vertalen in jouw website. Na ontvangst zullen wij zsm voor jou aan de slag gaan. Wij nemen binnen 3 dagen contact met je op.</p>
          <img src="https://api.phabsite.com/1609352675532-favicon4.png" alt="sitedata.name" class="logoimage">
        </span>
      </div>

      <modal v-if="showModal" @close="showModal = false" title="Delete site and users">
          <form @click.prevent="removeUser()">
              <p>Weet je zeker dat je deze website wil verwijderen?</p>
              <button class="button" type="submit">Ja, ik weet het zeker</button>
          </form>
      </modal>
  </div>
  </div>
</template>

<script>
  import Modal from '../components/modal/Modal.vue';
  import AlertBar from '../components/form/Alert.vue';
  import Loader from '../components/ui/Loader.vue';

  import { userService } from '../services/user.service.js';
  import { authHeader } from '../services/auth-header.js';
  
  import axios from 'axios';

  export default {
    props:{
    },
    data: function (){
      return {
        validcode: false,
        vipcode: this.$route.params.vipcode,
        showModal: false,
        content: {
          websiteid: "",
          site_title: "",
          site_description: "",
          aboutus: "",
          benefits: [
            {
              title: "",
              description: ""
            }
          ],
          offers: [
            {
              title: "",
              description: ""
            }
          ],
          references: [
            {
              title: "",
              description: ""
            }
          ],
          biotitle: "",
          bio: "",
          email: "",
          tel: "",
          comments: ""
        },
        msgtext: '',
        msgclass: 'error',
        loading: false,
        sentsuccess: false,
        settings: {},
        localcontent: JSON.parse(localStorage.getItem('yourText'))
      }
    },
    created () {
    },
    components: {
      AlertBar,
      Loader,
      Modal
    },
    watch: {
      content: {
          handler() {
            localStorage.setItem('yourText', JSON.stringify(this.content));
            this.msgtext = ''
        },
        deep: true
      }
    },
    methods: {
      eraseFields(){
        this.content= {
          site_title: "",
          site_description: "",
          aboutus: "",
          benefits: [
            {
              title: "",
              description: ""
            }
          ],
          offers: [
            {
              title: "",
              description: ""
            }
          ],
          references: [
            {
              title: "",
              description: ""
            }
          ],
          biotitle: "",
          bio: "",
          email: "",
          tel: "",
          comments: ""
        }
      },
      pushItems(target){
        let object = target;
        object.push({'title':'', 'description': ''})
      },
      checkCode(){
        axios.get(process.env.VUE_APP_ROOT_API+'/settings/vipcheck/'+this.vipcode)
        .then(
          response => {
            this.content.websiteid = response.data.response.websiteid
            this.validcode = true;
          },
          error => {
            this.msgtext = JSON.stringify(response)
            console.log(response)
          }
        )
      },
      sendForm(){
        if(!this.content.email){
          this.msgtext = 'Geef een e-mailadres op om aan een mooie site te beginnen.'
            this.loading = false
          return
        }
        
        this.loading = true
        
        const data = {
          email: this.content.email,
          settings: this.settings,
          content: this.content
        }

        axios.post(process.env.VUE_APP_ROOT_API+'/users/prefilled', data)
        .then(
          response => {
            this.msgclass = 'success'
            this.msgtext = JSON.stringify(response.data)
            this.loading = false
          },
          error => {
            let response = JSON.stringify(error)
            this.msgtext = 'Dit emailadres is al in gebruik'
            this.loading = false
          }
        )
      }
    },
    mounted(){
      if(this.vipcode){
        this.checkCode();
      }
        
      if (this.localcontent){
        this.content = this.localcontent
      }
    }
  }
</script>

<style lang="scss" scoped>
  .btn-primary {
    background: #0040ff !important;
  }
  a {
    color: #0073ff !important;
    text-decoration: underline;
  }

  .question{
    clear: both;
    padding-top: 20px;
  }

  .question:last-child::after{
    padding-bottom: 200px;
    clear: both;
    display: block;
    content: "";
  }

  .questionblock .edit_textarea{
    margin-top: 20px;
    margin-bottom: 20px;
  }

  .questionblock{
    padding-left: 50px;
    position: relative;
  }

  .questionblock:last-child .questionadder{
    display: inline-block;
  }

  .questionblock.nonumber{
    padding-left: 0;
  }
  
  .questionadder{
    display: none;
    width: 32px !important;
    height: 32px;
    border-radius: 40px;
    background: #ffffff;
    text-align: center;
    border: 0;
    font-size: 140%;
    line-height: 28px;
  }

  .questionnumber{
    display: inline-block;
    width: 32px !important;
    height: 32px;
    border-radius: 40px;
    background: rgba(255,255,255,0.06);
    position: absolute;
    left: 0;
    top: 8px;
    text-align: center;
  }

  .question-start{
    padding-top: 130px;
  }

  .question label{
    opacity: .5;
  }

  .question span{
    display: block;
    width: 100%;
  }

  .question-input{
    background: transparent;
    display: block !important;
    width: 100%;
    border-radius: 10px;
    color: #ffffffe1;
    border: 0;
    padding: 0px 5px !important;
    outline: none;
    resize: none;
    transition: all .15s ease-in-out;
  }
  .title-input{
    font-weight: 800;
    font-size: 120%;
    color: #ffffff;
  }
  .question-input.isempty{
    background: rgba(255,255,255,0.05);
    padding: 10px 20px !important;
    min-height: 50px;
  }
  .edit_textarea .editable_content{
    min-height: 100px;
  }
   .question-input.isempty:hover{
    background: rgba(255,255,255,0.06) !important;
  }

  .edit_field{
    display: block  !important;
  }

  @media (min-width: 768px) {

    .question{
      clear: both;
    }
    .question label{
      width: 25%;
      float: left;
      margin-right: 10%;
    }
    .question label + span, .question .questionblock{
      float: right;
      width: 64%;
    }
  }
  
</style>
